export const extractHiddenFlag = (str: Maybe<string>): boolean => {
  if (!str) return false;

  const parts = str.split('|').map(part => part.trim());

  const hiddenPart = parts.find(part => part.startsWith("{{'hidden'}}"));

  if (!hiddenPart) return false;

  const value = hiddenPart.split(':')[1]?.trim();
  return value === 'true';
};